import consumer from "./consumer"

var channel = null;

document.addEventListener('turbolinks:load', () => {
  if (document.getElementById('plotly')) {
    channel = consumer.subscriptions.create("DatasetUsageChannel", {
      connected() {
        // Called when th1e subscription is ready for use on the server
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
      },

      received(run) {
        let event = new CustomEvent('forecast', {detail: {run: run.id, success: run.success}})
        document.getElementById('plotly').dispatchEvent(event)

        let statusElem = document.querySelector(`[data-forecast-run-status="${run.id}"]`)
        if (statusElem) {
          statusElem.innerHTML = run.status
        }
        
        if (run.status !== 'Running') {
          let runElem = document.querySelector(`[data-forecast-run-running="${run.id}"]`)
          if (runElem) {
            runElem.remove();
          }
        }
      }
    });
  }
  else if (channel !== null) {
    channel.unsubscribe();
    channel = null;
  }
})

